import React from 'react';
import './QuizEndScreen.css';

const QuizEndScreen = props => {
	const minutes = props.elapsedTime[0];
	const seconds = props.elapsedTime[1];
	const [rCorrect, vCorrect, gCorrect, cCorrect] = props.perThemeCorrectAnswerCount;
	const [rTotal, vTotal, gTotal, cTotal] = props.perThemeTotalQuestions

	const perThemeQuestionRating = [
		<p key='r' className="reading-score">Reading: {rCorrect}/{rTotal}</p>,
		<p key='v' className="vocab-score">Vocabulary: {vCorrect}/{vTotal}</p>,
		<p key='g' className="grammar-score">Grammar: {gCorrect}/{gTotal}</p>,
		<p key='c' className="comp-score">Comprehension: {cCorrect}/{cTotal}</p>
	];

	const remarks = [
		'Try again, you need more practice.',
		'Keep Trying, you\'re learning quickly!',
		'Good Work, you\'re getting there!',
		'Great work, you really know your stuff'
	].filter((e, i) => {
		const percentage = props.totalCorrectAnswerCount / props.totalQuestions;
		if (percentage >= 0.75) return i === 3
		if (percentage < 0.75 && percentage >= 0.5) return i === 2
		if (percentage < 0.5 && percentage >= 0.25) return i === 1
		if (percentage < 0.25) return i === 0
		else return null;
	});

	const elapsedTime = `${minutes} minute${minutes > 1 ? 's' : ''} and ${seconds-1} second${(seconds-1) > 1 ? 's' : ''}!`;
	const questionComment = (
		<p className='quiz-end-screen-main-para'>
			You got {props.totalCorrectAnswerCount} out of {props.totalQuestions} answers correct in {elapsedTime}
		</p>
	);

	return (
		<div className='quiz-end-screen-container'>
			<h2>{remarks}</h2>
			{questionComment}
			<div className='end-of-quiz-screen-perTheme-ratings'>
				{perThemeQuestionRating}
			</div>
			<div className='end-of-quiz-screen-buttons-container'>
				<div onClick={() => props.startQuizOver()}>New Quiz</div>
				<div onClick={() => props.endQuiz()}>Close</div>
			</div>
		</div>
	)
};

export default QuizEndScreen;
